export const WebLink = (props: { link: string }) => {
  const href = props.link.startsWith("http")
    ? props.link
    : `https://${props.link}`;
  return <a href={href}>{props.link}</a>;
};
